import { useTablePagination } from '@/common/hooks/useTablePaginate'
import { useDateFilter } from '@/common/hooks/useDateFilter'
import { useQueryState } from 'nuqs'
import useQueryTrueWalletLogs from '../../api/hooks/useQueryTrueWalletLogs'
import useQueryTrueMoneyDeposits from '../../api/hooks/useQueryTrueMoneyDeposits'
import TrueWalletLogsTable from '../TrueWalletLogsTable'
import TrueMoneyDepositsSummaryCard from './components/TrueMoneyDepositsSummaryCard'
import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { DateRangePicker } from '@/common/components/DateRangePicker'
import DateRangeButtons from '@/common/components/DateRangeButtons'
import { PathsApiAdminBankTransactionsTrueWalletLogsGetParametersQuerySortByCreatedAt } from '@/schema'

export default function TrueWalletLogsListing() {
	const { pageSize, currentPage } = useTablePagination()
	const { dateFilter } = useDateFilter()
	const [phoneNumber] = useQueryState('phoneNumber')
	const [amount] = useQueryState('amount')

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		phoneNumber: phoneNumber || undefined,
		amount: amount ? Number(amount) : undefined,
		startDate: dateFilter.startDate || undefined,
		endDate: dateFilter.endDate || undefined,
		sortByCreatedAt:
			PathsApiAdminBankTransactionsTrueWalletLogsGetParametersQuerySortByCreatedAt.desc,
	}

	const { data, refetch, isLoading } = useQueryTrueWalletLogs(payload)

	// TrueMoney deposits summary data
	const trueMoneyPayload = {
		startDate: dateFilter.startDate || undefined,
		endDate: dateFilter.endDate || undefined,
	}
	const { data: trueMoneyData, isLoading: isLoadingTrueMoney } =
		useQueryTrueMoneyDeposits(trueMoneyPayload)

	const logsList = data?.data || []
	const totalLogs = data?.total || 0

	return (
		<div className="space-y-4 px-4 sm:px-0">
			{/* Header Section - Mobile Responsive */}
			<div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
				{/* Title */}
				<div className="space-y-3 sm:space-y-4">
					<Heading
						title="ประวัติทรูวอลเล็ต"
						description="รายการประวัติทรูวอลเล็ตทั้งหมด"
					/>
				</div>

				{/* Date Controls - Mobile Responsive */}
				<div className="flex flex-col gap-3 sm:items-end sm:gap-4">
					<DateRangePicker />
					<DateRangeButtons />
				</div>
			</div>

			<Separator className="my-4 sm:my-6" />

			{/* TrueMoney Deposits Summary */}
			<TrueMoneyDepositsSummaryCard
				data={trueMoneyData}
				isLoading={isLoadingTrueMoney}
			/>

			{/* Table Section */}
			<TrueWalletLogsTable
				data={logsList}
				total={totalLogs}
				onRefresh={refetch}
				isLoading={isLoading}
			/>
		</div>
	)
}
